<template>
  <div class="animated fadeIn">
  <b-breadcrumb><strong>Sample List</strong></b-breadcrumb>
    
  <b-row >
        <!-- <div class="design-container-details__main"> -->
      <div class="col-md-12 ">

        <b-card>
       
          <b-row class="col-md-12 ">            
              <b-col sm="3">
                    <label>Sub Category</label>
                    <b-form-group  
                      >
                      <b-form-select v-model="selected_subcat_id" id="selected_subcat_id" name="selected_subcat_id" @change="changesubcat(selected_subcat_id); subcatsearch(selected_subcat_id);">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="subcat_details.sub_catid" v-for="subcat_details in sub_cat_id_arr">{{ subcat_details.sub_cattitle }}</option>
                    </b-form-select>   
                    </b-form-group>  

              </b-col>
              
               <b-col sm="3">
                <label>Utility Type</label><br>
                <b-form-group >
                  

                  <b-form-select v-model="selected_utility_id" id="selected_utility_id" name="selected_utility_id" @change="utilitysearch(selected_utility_id)">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="utilitylist.utility_id" v-for="utilitylist in utility_type_arr">{{ utilitylist.utilitytype_title }}</option>
                    </b-form-select>                                
                </b-form-group>                   
              </b-col> 
              
              <b-col sm="3">
                <label>PO Type</label><br>
                <b-form-group >
                  
                  <b-form-select v-model="selected_po_id" id="selected_po_id" name="selected_po_id" @change="posearch(selected_po_id)">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="polist.po_id" v-for="polist in po_typearr">{{ polist.potype_title }}</option>
                    </b-form-select>                               
                </b-form-group>                   
              </b-col>

              <b-col sm="3">
                <label>Search</label><br>
                    <b-form-group >
                      <b-input-group>
                        <b-form-input type="text" v-model="search_item" name="first name" class="form-control" placeholder="Search" aria-label="Search" ></b-form-input>
                        <b-input-group-append>
                          <b-button type="submit" variant="primary"  @click="getdesignheadstyledetails()"><i class="fa fa-search" aria-hidden="true" >&nbsp;&nbsp;<b></b></i></b-button>
                          <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

            </b-row>
            <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ list_totalRows }}</span></b> </p>
              </b-col>
            <div class="col-md-12">
                    <b-table class="mt-4" show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="fields"  :current-page="currentPage" :perPage="perPage":bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>


                    <template slot="actions" slot-scope="row">
                      <i @click="editinfoModal(row.item)"  data-toggle="tooltip" title="Update Vendor Details" class="fa fa-pencil-square-o" aria-hidden="true" style=" color: green;">&nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- <i class="fa fa-edit"></i> -->
                      </i>
                      <i  v-on:click="deleteinfoModal(row.item)"  data-toggle="tooltip" title="Delete Vendor Details"  class="fa fa-trash" aria-hidden="true" style="color: red">
                         <!-- <i class="fa fa-trash" aria-hidden="true" style="color: red"></i> -->
                      </i>

                    </template>    
                    <template slot="action" slot-scope="row">
                      <!-- <button type="button" class="btn btn-info" style="width: 110px;" @click="opendesignModal(row.item)">Info</button> -->
                        <b-col md="12" class="pull-right text-right">
                          <!-- <div class="pull-right"> -->
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
                        <template v-slot:button-content>
                          <button @click="getrowdata(row.item)" style="border: none;" class="btn btn-link"><span class="cui-options icons font-1xl d-block" style="font-size: 15px;"></span></button>
                        </template>
                          <b-dropdown-item 
                          
                          target="_blank" >
                          <button v-b-modal.modal-lg type="button" class="btn btn-link" @click="opendesignModal(row.item)" v-if="user_type=='Fit_Technician' || user_type=='Design_Head' || user_type=='Admin' || user_type=='Quality_Head' || user_type=='Quality_Control'" ><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Style Details</button>
                          <router-link :to="'/design_details/' + route_id" v-if="user_type=='Brand_Manager' || user_type=='Buyer' || user_type=='Brand_Designer'" ><b-button type="submit" variant="primary" ><i class="fa fa-address-card-o" variant="primary" aria-hidden="true" style="color: green; margin-left: 5px;" ></i>Style Details</b-button>
                          </router-link>
                        </b-dropdown-item>

                          <!-- </b-dropdown-item> -->
                        </b-dropdown>
                      <!-- </div> -->
                        </b-col>
                    </template>        
                  </b-table>
                </div>
                      <b-col md="6" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="list_totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col> 
        </b-card>
      </div>
      <!-- </div>      -->

                   <!-- Code For Design Details Model -->
      <b-modal id="modal-lg" size="xl" title="Design Details" v-model="showdesigndetails" @ok="showdesigndetails = false">
      <b-row>
    
      <b-col sm="12" class='col-md-12'>
        
        <b-form name="addSegmentForm" @submit.prevent="updatestylestatus(comment,status)" >

                 <!-- <b-row class="col-md-12">
          
        </b-row> -->
         <b-row class="col-md-12">
            
            <b-col cols="4">
               <div style="float: left;
                  border: 1px solid lightgray;">
                  <img v-bind:src="img_path" alt="No Image To Show" height="220" width="270" style="padding:5px;"/>
                   <button v-b-modal.modal-lg type="button" class="btn btn-success" style="padding:5px;margin-left: 30%;"><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom Image</i></button>
                  <!-- <image-magnifier :src="img_path"
                    :zoom-src="img_path"
                    width="400"
                    height="300"
                    zoom-width="400"
                    zoom-height="300" style="padding:5px;"></image-magnifier> -->
                  <!-- <b-form-group style="margin-top:25px;">
                        
                    <b-form-group>
                        <b-col md="9">
                        </b-col>
                      <b-col md="3" class="pull-right"><img v-bind:src="img_path" height="100px" width="100px" /></b-col></b-form-group>
                    
                  </b-form-group>     -->              
               </div>

              
                  
              

            </b-col>
            <b-col cols="2"></b-col>

            <b-col cols="6" >
              
               
              <div  class='col-md-12' >    

                <!-- <b-col md="6" class="pull-left"> -->
                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Brand Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.brand_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Style Code</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.style_code}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Segment Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.segment_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Collection Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{customer.collection_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Sub Category Title</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.sub_cattitle}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Style Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.style_name}}
                   </b-col>
                  </b-form-group>


                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>PO Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.potype_title}}
                   </b-col>
                  </b-form-group>


                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Utility Type</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.utilitytype_title}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>No of Size Sets</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.no_of_sizeset}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Color</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.color}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Operational Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.operational_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Design Status</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.design_status}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Created By</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.full_name}}
                   </b-col>
                  </b-form-group>  

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Designer Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.designer_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Fit Tech Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.fit_tech_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Buyer Name</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.buyer_name}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Created Date</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.created_date}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Updated Date</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.updated_date}}
                   </b-col>
                  </b-form-group>

                  <b-form-group>
                    <b-col md="5" class="pull-left">
                     <label for="name"><b>Style Description</b></label>
                   </b-col> 
                   <b-col md="1" class="pull-left"><b>:</b></b-col>
                    
                   <b-col md="6" class="pull-right" >{{style_details.style_description}}
                   </b-col>
                  </b-form-group>

                </div>  
               
            </b-col>
         </b-row>

            

                    
                 

              <!-- </div> -->
            
            <div slot="footer"  style="margin-top:20px;text-align:right" v-if="(style_details.operational_status=='StyleNoCreated' || style_details.operational_status=='BH-approved') && user_type!='Buyer'">
            
              <b-form-group
                  label="Comment"
                  :label-cols="3" >
                  <b-form-textarea rows="3" max-rows="6" v-model="comment" type="text" name="comment"  
                  placeholder="Enter Comment Here...">
                  </b-form-textarea><br>
                  <b-input-group class="mb-3">
                      <label class="radio-inline"><input type="radio" name="optradio" value="approved" v-model="status" checked>&nbsp;Approved</label>&nbsp;&nbsp;
                      <label class="radio-inline"><input type="radio" name="optradio" value="rejected" v-model="status">&nbsp;Reject</label>&nbsp;&nbsp;

                      <label class="radio-inline"><input type="radio" name="optradio" value="Feedback" v-model="status">&nbsp;Feedback</label>                       
                    &nbsp;&nbsp;
                      </b-input-group>
                                 
                </b-form-group>
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update Status</b-button>
                  <b-button  size="sm" variant="danger" @click="commentcancel()">cancel</b-button>
                </div>

            </div>
         </b-form>
      </b-col>

    </b-row>
    </b-modal>
             <!-- Code For Design Details Ends -->

                       <!-- Image Zoom Model -->
    <b-modal id="modal-lg" size="lg" title="Image Zoom" v-model="openimagemodel" @ok="openimagemodel = false">
          <template slot="modal-header">
          <h5>Zoom Image</h5>
          <!-- <button type="button" class="close" aria-label="Close"  slot-scope="{ hide }">
            <span aria-hidden="true">&times;</span>
          </button> -->
          <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
          </template>
          <template slot="default" slot-scope="{ hide }">
            <div id="btn_navbar">
              <button type="button" class="btn btn-success" @click="zoomin()"><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom In</i></button>&nbsp;
              <button type="button" class="btn btn-danger" @click="zoomout()"><i class="fa fa-search-minus" aria-hidden="true">&nbsp;Zoom Out</i></button>
              </div>

              <div class="main1" style="text-align: center;">
              <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/>
              </div>


            

                <div slot="footer" class="text-right">
                 <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                  <b-button  size="sm" variant="danger" @click="openimagecancel()">cancel</b-button>
                </div>

          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal> 
            <!-- Image Zoom Model -->

      
  </b-row>    





    
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'
const axios = require('axios')
export default {
   name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data: function() {
    return {
      data: [],
      customer: {}, 
      brand_title: '',
      img_path: '',
      items:[],    
      selected:'',
      isBusy: false,   
      orderflow:'',
      Pickup:'',
      email:'',
      shipmenttype:'',
      shipmentstatus:'',
      hubid:'',
      user_type: '',
      data1:[],
      perPage:  20,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
      list_totalRows: 0,
      awbno:'',
      deliveryagentid:'',
      agentmaster: [],
      showdata: [],
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      hubdata:[],
      details:[],
      progressbar:[],
      openimagemodel: false,
      orderid:[],
      fields: [
          // { key: 'brand_title', label: 'Brand Title', sortable: true, sortDirection: 'desc' },
          // { key: 'segment_title', label: 'Segment Title', sortable: true},
          //  { key: 'collection_title', label: 'Collection Title', sortable: true},
            { key: 'design_title', label: 'Design Name' ,tdClass: 'nameOfTheClass'},
            
            { key: 'sub_cattitle', label: 'Subcat Title'},
            { key: 'potype_title', label: 'PO Type'},
            { key: 'designer_name', label: 'Designer Name'},
            // { key: 'style_image', label: 'Style Image'},
            { key: 'operational_status', label: 'Status'},
            { key: 'comments', label: 'Section Feedback'},
          { key: 'action', label: 'Action' ,tdClass: 'nameOfTheClass'},
         
      
       ],
     
      // fields: [
    
      //    // {key: 'orderdate', label: 'Order Date', sortable: true, sortDirection: 'desc' },
      //     { key: 'orderid', label:'Style Code',sortable: true,sortDirection:'desc'},
      //     { key: 'awbno', label: 'Brand Title', sortable: true},
      //     // { key: 'customermobilenumber', label: 'Customer-Number', sortable: true},
      //     { key: 'customername', label: 'Category/Sub Category', sortable: true},
      //     { key: 'vendoraddress', label: 'Order quantity', sortable: true,tdClass: 'nameOfTheClass'},          
      //     { key: 'destination', label: 'Target price', sortable: true ,tdClass: 'nameOfTheClass'}, 
      //      { key: 'destination', label: 'Quote price', sortable: true ,tdClass: 'nameOfTheClass'}, 
      //      { key: 'destination', label: 'Status', sortable: true ,tdClass: 'nameOfTheClass'}, 
           
         
      //     { key: 'deliverystatus', label: 'Updated At', sortable: true },
          
      //     { key: 'show_details', label: 'Action',tdClass: 'nameOfTheClass'},
         

      //   ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        searching:'',
        awbno:'',
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        po_typearr: [],
       selected_po_id: 0,
       utility_type_arr: [],
       sub_cat_id_arr : [],
       selected_subcat_id: 0,
       sub_cat: 0,
       selected_po_id: 0,
       selected_utility_id: 0,
       search_item: '',
       all_sample: '',
       search_subcat: 0,
       search_utility: 0,
       search_po: 0,
       style_details: [],
       showdesigndetails: false,
    };
  },
  computed: {
    // sortOptions() {
    //     // Create an options list from our fields
    //     return this.fields
    //       .filter(f => f.sortable)
    //       .map(f => {
    //         return { text: f.label, value: f.key }
    //       })
    //   }
  },
  created: function() {
    this.getdesignheadstyledetails(); 
    this.getSubCategoryList();
    var userData = localStorage.getItem('userData');
  var userInfo = JSON.parse(userData);
  this.user_type= userInfo[0].user_type;
  this.sub_cat_id_arr=userInfo[0].subcat_assign;
  this.route_id=this.$route.params.id;
  if(this.user_type=='Admin'){
    this.getSubCategoryList();
    }
    // if(this.user_type=='Admin'){
    
    // }
  },
  methods: {

    zoomin: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth >= 2500) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        } 
    },
    zoomout: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },
        openimagecancel: function(){
      this.openimagemodel = !this.openimagemodel;
     },
     

      getrowdata(value) {
          this.route_id=value.style_id; 
   },
   refresh: function(){
      this.selected_subcat_id= '';
      this.selected_utility_id= '';
      this.selected_po_id= '';
      this.search_item='';
      this.search_po=0;
      this.search_utility=0;
      this.search_subcat=0;
      // this.search_item=0;
      this.getdesignheadstyledetails(); 
    },
           /****** Function to design details ********/
       getdesigndetail: function () {
         document.getElementById("overlay").style.display = "block";
   
           this.isBusy = true;
       
           const Obj = {
                style_id: this.selected_style_id 
                             
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
              
            this.style_details  = this.result.returnvalue[0];
            this.img_path = this.style_details.style_image;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;                
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
           .catch(e => {
             this.errors.push(e)
           })
   
   
       },


      opendesignModal(value) {
          this.comment= '';
          this.status= '';
          this.selected_style_id = value.style_id;
          this.customer.brand_title = value.brand_title;
          this.customer.segment_title = value.segment_title;
          this.customer.collection_title = value.collection_title;
          this.customer.style_name = value.style_name;
          this.getdesigndetail();
          this.showdesigndetails =true;
          
   },
    getdesignheadstyledetails: function() 
    {
      document.getElementById("overlay").style.display = "block";
      this.isBusy = !this.isBusy;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.login_user_id = userInfo[0].user_id;
        const Obj={
            user_type: userInfo[0].user_type,
            keyword: this.all_sample,
            po_id: this.search_po,
            utility_id: this.search_utility,
            sub_catid: this.search_subcat,
            search_value: this.search_item,
             downloadalldata : 'no',
          }


 
        axios.post(`${CONSTANTS.API_URL}/getquotationlist_fashiohead`,Obj).then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
            
            this.items  = this.result.returnvalue; 

            this.list_totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            
          }else {
            this.isBusy = false;
           this.items =[];
           this.list_totalRows=0;
             // this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })



    },
         /******Function To Get Sub Category List********/
      getSubCategoryList: function(value) {    
       
      axios.post(`${CONSTANTS.API_URL}/getSubCategoryList`,{})
      .then(response => {
        //document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.isBusy = !this.isBusy;
          this.sub_cat_id_arr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          
          
        }else {
          this.isBusy = !this.isBusy;
         this.sub_cat_arr =[];
         this.totalRows=0;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },


   subcatsearch: function(value){
    this.search_subcat=0;
    this.search_subcat= value;
    this.getdesignheadstyledetails();
   },
   utilitysearch: function(value){
    this.search_utility= 0;
    this.search_utility=value;
    this.getdesignheadstyledetails();
   },
   posearch: function(value){
    this.search_po=0;
    this.search_po=value;
    this.getdesignheadstyledetails();
   },



   changesubcat(id){
    this.sub_cat= id;
    this.getUtilityTypeList();
    this.getPoTypeList();
   },

     /******Function To Get Utility Type List********/
      getUtilityTypeList: function() {
        // document.getElementById("overlay").style.display = "block";
      if(this.sub_cat=='')
      {
        this.sub_cat=0
      }  
      this.isBusy = true;  
      const Obj={
        subcat_id: this.sub_cat
      }   
      axios.post(`${CONSTANTS.API_URL}/getUtilityTypeList`,Obj)
      .then(response => {
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          // document.getElementById("overlay").style.display = "none";
          this.utility_type_arr  = this.result.returnvalue;
          console.log("this.utility_type_arr",this.utility_type_arr);
          this.totalRows = this.result.returnvalue.length;
          this.isBusy = !this.isBusy;
          
        }else {
         this.utility_type_arr =[];
         this.totalRows=0;
           // this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

  /******Function To Get Utility Type List Ends********/


  /******Function To Get PO Type List********/
      getPoTypeList: function() {
        // document.getElementById("overlay").style.display = "block";
       
      this.isBusy = true;  
      if(this.sub_cat=='')
      {
        this.sub_cat=0
      }    
       const Obj={
        subcat_id: this.sub_cat
       }
      axios.post(`${CONSTANTS.API_URL}/getPoTypeList`,Obj)
      .then(response => {
        // document.getElementById("overlay").style.display = "none";
        this.result = response.data

        if (this.result.returnmsg === 'Successful') {
          this.po_typearr  = this.result.returnvalue;
          this.totalRows = this.result.returnvalue.length;
          // this.isBusy = !this.isBusy;
          
        }else {
         this.po_typearr =[];
         this.totalRows=0;
           this.isBusy = !this.isBusy;
        }


      })
      .catch(e => {
        this.errors.push(e)
      })
    },

    info(item, shipmentid,index, button) {
      
      this.progressbar  = item;
      this.infoModal.title = 'Shipment Log - '+shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {},
    trybuyaddawb:function() {
       axios.post(`${CONSTANTS.MIGRATION_API_URL}/getmisreportadvanced`)
        .then(result => {
          if (result.data.returnmsg == "successful") {

            this.getDownloadCsvObject(result.data.returnvalue);
          
           alert('MIS Report Downloaded Successfully');
            //document.getElementById("loader").style.display = 'none';
          } else {
             alert(result.body.returnmsg);
         
      
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
     }, 
    getDownloadCsvObject: function(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear(); var ce
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
       document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var email=this.email;
      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      var orderflow=(this.orderflow!=null)? this.orderflow:"";
      var Pickup=(this.Pickup!=null)? this.Pickup:"";
      var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
      var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
      // var deliveryagentid=(this.deliveryagentid.key!=null)? this.deliveryagentid.key:"";
     
       if(shipmentstatus=="notassigned")
        {

         var csvObj = {
             shipmentstatus:shipmentstatus,
             sysusermasterid:`${userInfo.sysusermasterid}`, 
             // page_no:1,
           };

        }
        else if(this.searching)
        {
          var csvObj = {
             fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid.key,
            shippingid:'',
            email:`${this.email}`,
            search_text:this.searching,
            sysusermasterid:`${userInfo.sysusermasterid}`, 
             // page_no:1,
           };
         
        }
        else{
          if(this.deliveryagentid.key==undefined)
          {
          var   deliveryagentid="";
          }
          else
          {
           var  deliveryagentid=this.deliveryagentid.key;
          }
          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:deliveryagentid,
            shippingid:'',
            email:`${this.email}`,
            sysusermasterid:`${userInfo.sysusermasterid}`,
            // page_no:1,

          };
         
        }
 

      //console.log(csvObj);
      
        // var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
      if(formatdateto< fromdate){
        alert('To date need to be grater than From date');
          
      }
      //var r = Math.random().toString(36).substring(3);
      axios.post(`${CONSTANTS.MIGRATION_API_URL}/getmisreportcsv_advanced`,csvObj)
        .then(result => {
          document.getElementById("overlay").style.display = "none";
           if(result.body=="success")
         {
         alert("Please Check Ur Mail For Downlod Link")
       }
       else
       {
        alert("Can not Download");
       }
         // console.log(result.url);
       // window.location.href =result.url;
        });
        
    },
//     downloadCSV: function() {
//       var email=this.email;
//       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
//       var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
//       var orderflow=(this.orderflow!=null)? this.orderflow:"";
//       var Pickup=(this.Pickup!=null)? this.Pickup:"";
//       var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
//       var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
//       //var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
     
//        if(shipmentstatus=="notassigned")
//         {

//          var csvObj = {
//              shipmentstatus:shipmentstatus,
//            };

//         }
//         else{
//           var csvObj = {
//             fromdate: `${fromdate}`,
//             todate:`${formatdateto}`,
//             serviceid: `${this.hubid}`,
//             orderflow:orderflow,
//             Pickup:Pickup,
//             shipmentstatus:shipmentstatus,
//             shipmenttype:shipmenttype,
//             deliveryagentid:this.deliveryagentid.key,
//             shippingid:'',
//             email:`${this.email}`
//           };
         
//         }
 

//       //console.log(csvObj);
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
//       if(formatdateto< fromdate){
//         alert('To date need to be grater than From date');
          
//       }
//       //var r = Math.random().toString(36).substring(3);
//       this.$http
//         .get(`${CONSTANTS.MISREPORT_API_URL}/getmisreportcsv`+queryString)
//         .then(result => {
//          console.log(result.url);
//         window.location.href =result.url;
//         });
        
//     },
  clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showCSV(pageNum);
    },
     showCSV: function(pagee) {
     // alert(pagee);
     
       this.isBusy = true;
      // console.log('test '+this.orderflow);
      //  document.getElementById("loader").style.display = 'block'
      var center = this.hubid;
      if(center == undefined){
        alert('Please select center');       
        
      }else{
        var email=this.email;
        var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        var orderflow=(this.orderflow!=null && this.orderflow!='')? this.orderflow:"both";
         var Pickup=(this.Pickup!=null && this.Pickup!='')? this.Pickup:"";
        
        var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
       

        if(shipmentstatus=="notassigned")
        {

         var csvObj = {
             shipmentstatus:shipmentstatus,
             page_no:1,
           };

        }
        else if(this.searching)
        {
          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid.key,
            shippingid:'',
            email:`${this.email}`,
            //page_no:pagee,
            search_text:this.searching,
            
           };
         
        }
        else{

          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid.key,
            shippingid:'',
            email:`${this.email}`,
            page_no:pagee,
            search_text:this.searching,
          };
         
        }
 

        if(formatdateto< fromdate){
           alert('To date need to be grater than From date');          
        }

        axios.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportadvanced`, csvObj)
          .then(result => {
             this.isBusy = !this.isBusy;

          //  document.getElementById("loader").style.display = 'none'
            if (result.body.returnmsg && result.body.returnmsg === 'successful') {
                 // console.log(result.body.returnvalue[0]);
                this.showdata = result.body.returnvalue[0].shippingidlist;
                this.items  = result.body.returnvalue[0].shippingidlist;
               
                this.totalRows = result.body.returnvalue[0].totalrecords;  

           this.noofpages=parseInt(this.totalRows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);        
            }else{
             this.showdata = []
              this.items  = [];
              this.totalRows = 0;               
             
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
      }
    },


    
    status: function() {
     
    if(this.shipmentstatus=="notassigned")
     {

     var csvObj = {
          
          shipmentstatus:"notassigned"
         
        };
        
      }
     },



    
    convertArrayOfObjectsToCSV: function(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data;
       data = args.data || null;
       if (data == null || !data.length) {
         return null; var ce
       }
      

       columnDelimiter = args.columnDelimiter || ",";
       lineDelimiter = args.lineDelimiter || "\n";

       //.slice(0,-4)
       keys = Object.keys(data[0]);
       
       result = "";
       result += keys.join(columnDelimiter);
       result += lineDelimiter;
       data.forEach(function(item) {
       var logdata = item['logdata'];
       var attempt = item['attempt'];
       var allowcheckedin = item['allowcheckedin']

        item['pickupcheckintime'] = null;
        item['pickuptime'] = null;

        item['orderconfirmedtime'] = null;
        item['deliverytime'] = null;
        item['ordercreationtimestamp'] = "'"+item['ordercreationtimestamp'];
        item['scheduledstarttime'] = "'"+item['scheduledstarttime'];
        item['scheduledendtime'] = "'"+item['scheduledendtime'];

         if(logdata!==null){

           logdata.forEach(function(itm){
             let mydate = new Date(itm.createddate);
             let month=mydate.getMonth()+1;
             let createddate="'"+mydate.getFullYear()+"-"+month+"-"+mydate.getDate()+" "+mydate.getHours()+":"+mydate.getMinutes();
             switch(itm.process) {
               case 'BookingDone':
                   if(attempt !== null)
                   {
                       if(attempt == itm.attempt)
                       {
                         item['orderconfirmedtime'] = createddate.toString();
                         break;
                       }
                    }else {
                       item['orderconfirmedtime'] = createddate.toString();
                      break;
                    }
               case 'OFD':
                    if(attempt !== null)
                   {
                       if(attempt == itm.attempt)
                       {
                         if(allowcheckedin == 'true'){
                           item['pickupcheckintime'] = item['pickupcheckintime1'];
                           item['pickuptime'] = createddate.toString();
                           break;
                         }else {

                           item['pickupcheckintime'] = createddate.toString();
                           item['pickuptime'] = createddate.toString();
                           break;
                         }
                       }
                  }else {
                    if(allowcheckedin == 'true'){
                      item['pickupcheckintime'] = item['pickupcheckintime1'];
                      item['pickuptime'] = createddate.toString();
                      break;
                    }else {
                      item['pickupcheckintime'] = createddate.toString();
                      item['pickuptime'] = createddate.toString();
                      break;
                    }
                  }
               case 'DLV':
                 if(attempt !== null)
                 {
                     if(attempt == itm.attempt)
                     {
                        if(allowcheckedin == 'true'){
                           item['deliverycheckintime'] = item['deliverycheckintime1'];
                           item['deliverytime'] = createddate.toString();
                           break;
                        }else {
                          item['deliverycheckintime'] = createddate.toString();
                          item['deliverytime'] = createddate.toString();
                          break;
                        }
                     }
                }else {
                    if(allowcheckedin == 'true'){
                       item['deliverycheckintime'] = item['deliverycheckintime1'];
                       item['deli var ceverytime'] = createddate.toString();
                       break;
                    }else {
                      item['deliverycheckintime'] = createddate.toString();
                      item['deliverytime'] = createddate.toString();
                      break;
                    }
                }

                case 'NDR':
                  if(attempt !== null)
                  {
                      if(attempt == itm.attempt)
                      {
                        item['deliverycheckintime'] = null;
                        item['deliverytime'] = null;
                        break;
                      }
                 }else {
                        item['deliverycheckintime'] = null;
                        item['deliverytime'] = null;
                     break;
                 }
             }
           });
         } else {
           item['deliverytime'] = '';
           item['orderconfirmedtime'] = '';
           item['pickupcheckintime'] = '';
           item['pickuptime'] = '';
         }
         ctr = 0;
        

         keys.forEach(function(key) {
          // console.log('--------------------');
          // console.log(key);
              //       console.log('-----datta---------------');
//&& key!='logdata'
           if (ctr > 0) result += columnDelimiter;
           if (item[key] != null && key!='logdata') {

            if(key=='origin'){
                var str2=item[key];
                str2=str2.replace('#','');
                result += '"' +str2 + '"';
             }else{
             result += '"' + item[key] + '"';
             }      
           }           
           
           ctr++;
         });
         result += lineDelimiter;
       });
     //  document.getElementById("loader").style.display = 'none';

       return result;
     },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },
      clear: function() {
   this.searching="";
   this.deliveryagentid="";
   this.Pickup="";
   this.shipmentstatus="";
   this.shipmenttype="";
   // this.selectDateFrom="";
   // this.selectDateTo="";
    this.filter="";
    this.showCSV(this.pageNum);
   
   
      
    },
   
    displayHubdata: function() {
      const deliveryagentobj = {}
      axios.post(`${CONSTANTS.API_URL}/P2PReports/GetAllHubListMaster`)
        .then(result => {
          this.hubdata = result.body.returnvalue;
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },




    MisReportdetails: function(shipmentid,showhide) {
        var showhides=showhide;
      
 if(showhides)
 {

 }
 else{
      
 
 var awbno = shipmentid;
 //alert(awbno)

  var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";

       
        var shippingidobj = {
          fromdate: `${fromdate}`,
          todate:`${formatdateto}`,
          serviceid: `${this.hubid}`,
          shippingid: `${awbno}`
        };

      axios.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportdetails`,shippingidobj)
        .then(result => {
          this.details = result.body.returnvalue;
          //console.log(this.details);
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
      }
    },




    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
      axios.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          // this.agentmaster = result.body
          this.data1 = result.body
           var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
                });
              });
              this.data1 = data;
          
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
  padding: .2rem!important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
  .nameOfTheClass {
   max-width: 450px !important;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}


/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
